<template>
    <div class="dash-wrapper">
        <div class="dash-header">
            <div>
                <h1 class="dash-title">System Overview</h1>
                <p class="dash-subtitle">Platform-wide metrics across every company on BidSnap AI</p>
            </div>
            <div class="date-pill">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                    <line x1="16" y1="2" x2="16" y2="6" />
                    <line x1="8" y1="2" x2="8" y2="6" />
                    <line x1="3" y1="10" x2="21" y2="10" />
                </svg>
                {{ todayLabel }}
            </div>
        </div>

        <!-- KPI cards -->
        <div class="stats-grid">
            <div class="stat-card blue">
                <div class="stat-glow"></div>
                <div class="stat-mesh"></div>
                <div class="stat-top">
                    <div class="stat-icon">
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M3 21h18" />
                            <path d="M5 21V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16" />
                            <path d="M9 8h1M9 12h1M9 16h1M14 8h1M14 12h1M14 16h1" />
                        </svg>
                    </div>
                    <span class="stat-chip">TOTAL</span>
                </div>
                <h2 class="stat-value">{{ stats.total_companies }}</h2>
                <p class="stat-label">Companies</p>
                <div class="stat-foot">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M12 20V10M18 20V4M6 20v-4"/></svg>
                    Onboarded clients
                </div>
            </div>

            <div class="stat-card purple">
                <div class="stat-glow"></div>
                <div class="stat-mesh"></div>
                <div class="stat-top">
                    <div class="stat-icon">
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                            <circle cx="9" cy="7" r="4" />
                            <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                        </svg>
                    </div>
                    <span class="stat-chip">ALL</span>
                </div>
                <h2 class="stat-value">{{ stats.total_users }}</h2>
                <p class="stat-label">Total Users</p>
                <div class="stat-foot">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/></svg>
                    Across every company
                </div>
            </div>

            <div class="stat-card amber">
                <div class="stat-glow"></div>
                <div class="stat-mesh"></div>
                <div class="stat-top">
                    <div class="stat-icon">
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                            <polyline points="14 2 14 8 20 8" />
                        </svg>
                    </div>
                    <span class="stat-chip">PROCESSED</span>
                </div>
                <h2 class="stat-value">{{ stats.total_pdfs }}</h2>
                <p class="stat-label">PDFs Analyzed</p>
                <div class="stat-foot">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
                    AI document intelligence
                </div>
            </div>

            <div class="stat-card rose">
                <div class="stat-glow"></div>
                <div class="stat-mesh"></div>
                <div class="stat-top">
                    <div class="stat-icon">
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                        </svg>
                    </div>
                    <span class="stat-chip">ISSUED</span>
                </div>
                <h2 class="stat-value">{{ stats.total_licenses }}</h2>
                <p class="stat-label">Total Licenses</p>
                <div class="stat-foot">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                    Platform-wide seats
                </div>
            </div>

            <div class="stat-card green">
                <div class="stat-glow"></div>
                <div class="stat-mesh"></div>
                <div class="stat-top">
                    <div class="stat-icon">
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                            <polyline points="22 4 12 14.01 9 11.01" />
                        </svg>
                    </div>
                    <span class="stat-chip">READY</span>
                </div>
                <h2 class="stat-value">{{ stats.active_licenses }}</h2>
                <p class="stat-label">Unused Licenses</p>
                <div class="stat-foot">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
                    Available to assign
                </div>
            </div>
        </div>

        <!-- Secondary row: license utilization + recent companies -->
        <div class="mid-grid">
            <div class="panel util-panel">
                <div class="panel-head">
                    <h3 class="panel-title">License Utilization</h3>
                </div>
                <div class="ring-wrap">
                    <svg class="ring" viewBox="0 0 120 120">
                        <circle class="ring-bg" cx="60" cy="60" r="52" />
                        <circle class="ring-fg" cx="60" cy="60" r="52"
                            :stroke-dasharray="ringCircumference"
                            :stroke-dashoffset="ringOffset(licenseUtilPct)" />
                    </svg>
                    <div class="ring-center">
                        <span class="ring-pct">{{ licenseUtilPct }}%</span>
                        <span class="ring-cap">Used</span>
                    </div>
                </div>
                <div class="ring-foot">
                    <div><strong>{{ stats.total_licenses - stats.active_licenses }}</strong><span>Assigned</span></div>
                    <div><strong>{{ stats.active_licenses }}</strong><span>Available</span></div>
                    <div><strong>{{ stats.total_licenses }}</strong><span>Total</span></div>
                </div>
            </div>

            <div class="panel recent-panel">
                <div class="panel-head">
                    <div>
                        <h3 class="panel-title">Recently Added Companies</h3>
                        <p class="panel-sub">Newest client organizations onboarded to the platform</p>
                    </div>
                    <router-link to="/companies" class="see-all">View all</router-link>
                </div>
                <div v-if="recentCompaniesLoading" class="panel-loading">Loading…</div>
                <ul v-else-if="recentCompanies.length" class="recent-list">
                    <li v-for="c in recentCompanies" :key="c.id" class="recent-item" @click="$router.push('/companies/' + c.id)">
                        <div class="recent-avatar">{{ initials(c.name) }}</div>
                        <div class="recent-body">
                            <p class="recent-name">{{ c.name }}</p>
                            <span class="recent-meta">{{ c.contact_person_name || 'No contact set' }}</span>
                        </div>
                        <span class="recent-badge" :class="c.is_active ? 'active' : 'inactive'">
                            {{ c.is_active ? 'Active' : 'Inactive' }}
                        </span>
                    </li>
                </ul>
                <div v-else class="panel-empty">No companies registered yet.</div>
            </div>
        </div>

        <!-- Notification Management Panel -->
        <div class="panel notif-panel">
            <div class="panel-head">
                <div>
                    <h3 class="panel-title">Notification Management</h3>
                    <p class="panel-sub">Force send reminder emails and system notifications to all active company users instantly. This skips the daily scheduler and duplicate checks.</p>
                </div>
                <div class="notif-actions">
                    <button @click="sendDemoNotification" :disabled="isSendingDemo" class="demo-btn">
                        <svg v-if="isSendingDemo" class="spin-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M21 12a9 9 0 1 1-6.219-8.56"></path>
                        </svg>
                        <svg v-else width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                            <polyline points="22,6 12,13 2,6"></polyline>
                        </svg>
                        {{ isSendingDemo ? 'Sending Demo...' : 'Send Demo Email' }}
                    </button>

                    <button @click="forceSendNotifications" :disabled="isSending" class="force-btn">
                        <svg v-if="isSending" class="spin-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M21 12a9 9 0 1 1-6.219-8.56"></path>
                        </svg>
                        <svg v-else width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <line x1="22" y1="2" x2="11" y2="13"></line>
                            <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                        </svg>
                        {{ isSending ? 'Sending Notifications...' : 'Force Notifications' }}
                    </button>
                </div>
            </div>

            <!-- Demo Notification Card -->
            <div class="email-preview-box">
                <h4 class="email-preview-label">Email Preview Demo</h4>
                <div class="email-card">
                    <div class="email-card-head">
                        <h3>Bid Deadline Alert</h3>
                    </div>
                    <div class="email-card-body">
                        <p class="email-greeting">Hello <b>[User Name]</b>,</p>
                        <p class="email-text">This is an automated reminder regarding the upcoming bid deadline for project:<br><br><b class="email-project">[Project Name]</b></p>
                        <div class="email-meta-box">
                            <p><b>Due Date:</b> 25-Oct-2024</p>
                            <p><b>Status:</b> <span class="email-status">2 day(s) remaining</span></p>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="notificationMessage" class="notif-result" :class="notificationType">
                {{ notificationMessage }}
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'SuperAdminDashboard',
    data() {
        return {
            stats: { total_companies: 0, total_users: 0, total_pdfs: 0, total_licenses: 0, active_licenses: 0 },
            recentCompanies: [],
            recentCompaniesLoading: true,
            isSending: false,
            isSendingDemo: false,
            notificationMessage: '',
            notificationType: 'success',
            ringCircumference: 2 * Math.PI * 52
        }
    },
    computed: {
        todayLabel() {
            return new Date().toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
        },
        licenseUtilPct() {
            if (!this.stats.total_licenses) return 0;
            const used = this.stats.total_licenses - this.stats.active_licenses;
            return Math.round((used / this.stats.total_licenses) * 100);
        }
    },
    methods: {
        ringOffset(pct) {
            return this.ringCircumference * (1 - (pct || 0) / 100);
        },
        initials(name) {
            if (!name) return '?';
            return name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2);
        },
        async fetchRecentCompanies() {
            this.recentCompaniesLoading = true;
            try {
                const response = await axios.get(`${this.$API_URL}/super_admin/companies?page=1&page_size=100`, {
                    headers: { Authorization: `Bearer ${localStorage.getItem('super_admin_token')}` }
                });
                const items = response.data.items || [];
                this.recentCompanies = items
                    .slice()
                    .sort((a, b) => (b.id || 0) - (a.id || 0))
                    .slice(0, 5);
            } catch (error) {
                console.error('Error fetching recent companies:', error);
            } finally {
                this.recentCompaniesLoading = false;
            }
        },
        async forceSendNotifications() {
            if (!confirm('Are you sure you want to force send reminder emails to ALL valid users instantly? This skips the duplicate check and may resend emails if already sent today.')) return;

            this.isSending = true;
            this.notificationMessage = '';

            try {
                const response = await axios.post(`${this.$API_URL}/super_admin/force-notify`, {}, {
                    headers: { Authorization: `Bearer ${localStorage.getItem('super_admin_token')}` }
                });
                this.notificationType = 'success';
                this.notificationMessage = response.data.message || 'Notifications forced successfully to all users.';
            } catch (error) {
                console.error('Error forcing notifications:', error);
                this.notificationType = 'error';
                this.notificationMessage = error.response?.data?.detail || 'Failed to send notifications. Check backend logs.';
            } finally {
                this.isSending = false;
                setTimeout(() => { this.notificationMessage = ''; }, 7000);
            }
        },
        async sendDemoNotification() {
            this.isSendingDemo = true;
            this.notificationMessage = '';

            try {
                const response = await axios.post(`${this.$API_URL}/super_admin/demo-notify`, {}, {
                    headers: { Authorization: `Bearer ${localStorage.getItem('super_admin_token')}` }
                });
                this.notificationType = 'success';
                this.notificationMessage = response.data.message || 'Demo email sent successfully.';
            } catch (error) {
                console.error('Error sending demo notification:', error);
                this.notificationType = 'error';
                this.notificationMessage = error.response?.data?.detail || 'Failed to send demo email via SendGrid.';
            } finally {
                this.isSendingDemo = false;
                setTimeout(() => { this.notificationMessage = ''; }, 7000);
            }
        }
    },
    async mounted() {
        try {
            const response = await axios.get(`${this.$API_URL}/super_admin/stats`, {
                headers: { Authorization: `Bearer ${localStorage.getItem('super_admin_token')}` }
            });
            this.stats = response.data;
        } catch (error) {
            console.error('Error fetching stats:', error);
        }
        this.fetchRecentCompanies();
    }
}
</script>

<style scoped>
.dash-wrapper {
    width: 100%;
    font-family: var(--font-sans);
}

/* ===== Header ===== */
.dash-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 1rem;
    margin-bottom: 1.75rem;
}

.dash-title {
    font-family: var(--font-display);
    font-size: var(--fs-h1);
    line-height: var(--lh-h1);
    font-weight: var(--fw-h1);
    color: var(--text-primary);
    margin: 0;
    letter-spacing: -0.02em;
}

.dash-subtitle {
    color: var(--text-secondary);
    margin: var(--space-heading-body) 0 0;
    font-size: var(--fs-sm);
    line-height: var(--lh-sm);
    font-weight: var(--fw-sm);
}

.date-pill {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background: #fff;
    border: 1px solid #e2e8f0;
    color: #475569;
    font-weight: 600;
    font-size: 0.85rem;
    padding: 0.6rem 1rem;
    border-radius: 12px;
    white-space: nowrap;
}

/* ===== KPI Cards ===== */
.stats-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1.25rem;
    margin-bottom: 1.5rem;
}

.stat-card {
    position: relative;
    border-radius: 22px;
    padding: 1.5rem 1.5rem 1.25rem;
    color: #fff;
    overflow: hidden;
    box-shadow:
        0 1px 0 rgba(255, 255, 255, 0.25) inset,
        0 16px 32px -12px rgba(0, 0, 0, 0.4);
    transition: transform 0.3s cubic-bezier(0.2, 0.8, 0.2, 1), box-shadow 0.3s;
}

.stat-card:hover {
    transform: translateY(-5px);
    box-shadow:
        0 1px 0 rgba(255, 255, 255, 0.3) inset,
        0 22px 40px -12px rgba(0, 0, 0, 0.48);
}

.stat-card.blue { background: linear-gradient(150deg, #2f9bff 0%, #0071C5 55%, #005a9e 100%); }
.stat-card.purple { background: linear-gradient(150deg, #a78bfa 0%, #7c3aed 55%, #5b21b6 100%); }
.stat-card.amber { background: linear-gradient(150deg, #fbbf24 0%, #f59e0b 55%, #b45309 100%); }
.stat-card.rose { background: linear-gradient(150deg, #fb7185 0%, #e11d48 55%, #9f1239 100%); }
.stat-card.green { background: linear-gradient(150deg, #34d399 0%, #059669 55%, #065f46 100%); }

/* Faint grid texture — echoes the sidebar's tech-grid motif */
.stat-mesh {
    position: absolute;
    inset: 0;
    background-image:
        linear-gradient(rgba(255, 255, 255, 0.08) 1px, transparent 1px),
        linear-gradient(90deg, rgba(255, 255, 255, 0.08) 1px, transparent 1px);
    background-size: 18px 18px;
    -webkit-mask-image: radial-gradient(120% 100% at 100% 0%, #000 0%, transparent 70%);
    mask-image: radial-gradient(120% 100% at 100% 0%, #000 0%, transparent 70%);
    pointer-events: none;
}

.stat-glow {
    position: absolute;
    width: 150px;
    height: 150px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.16);
    top: -60px;
    right: -40px;
    filter: blur(6px);
}

.stat-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    z-index: 2;
}

.stat-icon {
    width: 46px;
    height: 46px;
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.16);
    border: 1px solid rgba(255, 255, 255, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(4px);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12) inset;
}

.stat-chip {
    font-size: 0.62rem;
    font-weight: 800;
    letter-spacing: 0.08em;
    padding: 4px 9px;
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.16);
    border: 1px solid rgba(255, 255, 255, 0.25);
    opacity: 0.9;
}

.stat-value {
    font-family: var(--font-display);
    font-size: var(--fs-metric);
    line-height: var(--lh-metric);
    font-weight: var(--fw-metric);
    margin: 1.1rem 0 0;
    position: relative;
    z-index: 2;
    letter-spacing: -0.02em;
    font-variant-numeric: tabular-nums;
    text-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
}

.stat-label {
    margin: 0.2rem 0 0;
    font-size: 0.88rem;
    font-weight: 700;
    opacity: 0.95;
    position: relative;
    z-index: 2;
}

.stat-foot {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: 0.9rem;
    padding-top: 0.75rem;
    border-top: 1px solid rgba(255, 255, 255, 0.18);
    font-size: 0.72rem;
    font-weight: 600;
    opacity: 0.85;
    position: relative;
    z-index: 2;
}

.stat-foot svg { flex-shrink: 0; opacity: 0.85; }

/* ===== Panels (shared) ===== */
.panel {
    background: #fff;
    border: 1px solid #eef2f7;
    border-radius: 20px;
    padding: 1.75rem;
    box-shadow: 0 6px 20px rgba(15, 23, 42, 0.04);
}

.panel-head {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 1rem;
    margin-bottom: 1.5rem;
}

.panel-title {
    font-size: var(--fs-h2);
    line-height: var(--lh-h2);
    font-weight: var(--fw-h2);
    color: var(--text-primary);
    margin: 0;
}

.panel-sub {
    color: var(--text-secondary);
    margin-top: 0.5rem;
    max-width: 600px;
    font-size: var(--fs-sm);
    line-height: 1.55;
}

.see-all {
    font-size: 0.8rem;
    font-weight: 700;
    color: #0084FF;
    text-decoration: none;
    white-space: nowrap;
}

.see-all:hover { text-decoration: underline; }

/* ===== Mid grid: utilization ring + recent companies ===== */
.mid-grid {
    display: grid;
    grid-template-columns: 1fr 2fr;
    gap: 1.25rem;
    margin-bottom: 1.5rem;
}

.util-panel { display: flex; flex-direction: column; }

.ring-wrap {
    position: relative;
    width: 160px;
    height: 160px;
    margin: 0.25rem auto 1rem;
}

.ring {
    width: 100%;
    height: 100%;
    transform: rotate(-90deg);
}

.ring-bg {
    fill: none;
    stroke: #eef2f7;
    stroke-width: 12;
}

.ring-fg {
    fill: none;
    stroke: #0084FF;
    stroke-width: 12;
    stroke-linecap: round;
    transition: stroke-dashoffset 1s cubic-bezier(0.4, 0, 0.2, 1);
    filter: drop-shadow(0 0 6px rgba(0, 132, 255, 0.5));
}

.ring-center {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.ring-pct {
    font-size: 2rem;
    font-weight: 700;
    color: #0f172a;
    line-height: 1;
}

.ring-cap {
    font-size: 0.78rem;
    font-weight: 600;
    color: #94a3b8;
    margin-top: 0.2rem;
}

.ring-foot {
    display: flex;
    justify-content: space-around;
    border-top: 1px solid #f1f5f9;
    padding-top: 1rem;
    margin-top: auto;
}

.ring-foot div {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.ring-foot strong {
    font-family: var(--font-display);
    font-size: var(--fs-h3);
    line-height: var(--lh-h3);
    font-weight: var(--fw-h3);
    color: var(--text-primary);
    font-variant-numeric: tabular-nums;
}

.ring-foot span {
    font-size: 0.72rem;
    color: #94a3b8;
    font-weight: 600;
}

/* Recent companies list */
.recent-list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
}

.recent-item {
    display: flex;
    align-items: center;
    gap: 0.85rem;
    padding: 0.65rem 0.5rem;
    border-radius: 12px;
    cursor: pointer;
    transition: background 0.2s;
}

.recent-item:hover { background: #f8fafc; }

.recent-avatar {
    width: 40px;
    height: 40px;
    border-radius: 12px;
    background: linear-gradient(135deg, #0084FF, #0071C5);
    color: #fff;
    font-size: 0.78rem;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.recent-body { flex: 1; min-width: 0; }

.recent-name {
    margin: 0;
    font-size: 0.9rem;
    font-weight: 700;
    color: #1e293b;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.recent-meta {
    font-size: 0.76rem;
    color: #94a3b8;
    font-weight: 500;
}

.recent-badge {
    font-size: 0.68rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    padding: 3px 10px;
    border-radius: 20px;
    flex-shrink: 0;
}

.recent-badge.active { background: rgba(16, 185, 129, 0.12); color: #10b981; }
.recent-badge.inactive { background: rgba(244, 63, 94, 0.12); color: #f43f5e; }

.panel-loading, .panel-empty {
    color: #94a3b8;
    font-size: 0.85rem;
    padding: 1.5rem 0;
    text-align: center;
}

/* ===== Notification panel ===== */
.notif-actions {
    display: flex;
    gap: 1rem;
}

.force-btn {
    background: linear-gradient(90deg, #0071C5, #0084FF);
    color: white;
    padding: 0.75rem 1.5rem;
    border: none;
    border-radius: 12px;
    font-weight: 700;
    font-family: var(--font-sans);
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    transition: all 0.2s;
    font-size: var(--fs-btn);
    box-shadow: 0 6px 16px rgba(0, 113, 197, 0.35);
}

.force-btn:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 10px 22px rgba(0, 113, 197, 0.45);
}

.force-btn:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

.spin-icon {
    animation: spin 1s linear infinite;
}

@keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
}

.demo-btn {
    background: transparent;
    color: #0071C5;
    padding: 0.75rem 1.5rem;
    border: 2px solid #0071C5;
    border-radius: 12px;
    font-weight: 700;
    font-family: var(--font-sans);
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    transition: all 0.2s;
    font-size: var(--fs-btn);
}

.demo-btn:hover:not(:disabled) {
    background: #f0f7ff;
    transform: translateY(-2px);
}

.demo-btn:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

/* Email preview */
.email-preview-box {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    padding: 1.5rem;
}

.email-preview-label {
    color: var(--text-secondary);
    margin: 0 0 1rem;
    font-size: var(--fs-caption);
    text-transform: uppercase;
    letter-spacing: 0.05em;
    font-weight: 700;
}

.email-card {
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    overflow: hidden;
    max-width: 500px;
    box-shadow: 0 4px 12px rgba(15, 23, 42, 0.05);
}

.email-card-head {
    background: linear-gradient(90deg, #0071C5, #0084FF);
    padding: 15px;
    text-align: center;
}

.email-card-head h3 {
    color: white;
    margin: 0;
    font-size: 1.1rem;
}

.email-card-body {
    padding: 20px;
}

.email-greeting {
    margin-top: 0;
    color: #333;
}

.email-text {
    color: #475569;
    font-size: 0.95rem;
    line-height: 1.5;
}

.email-project {
    color: #0071C5;
    font-size: 1.1rem;
}

.email-meta-box {
    background: #f1f5f9;
    padding: 12px;
    border-radius: 6px;
    margin: 15px 0;
}

.email-meta-box p {
    margin: 3px 0;
    font-size: 0.9rem;
    color: #333;
}

.email-status {
    color: #f59e0b;
    font-weight: bold;
}

.notif-result {
    margin-top: 1.5rem;
    padding: 1rem;
    border-radius: 12px;
    font-weight: 600;
    font-size: var(--fs-sm);
}

.notif-result.success {
    background: #dcfce7;
    color: #166534;
    border: 1px solid #bbf7d0;
}

.notif-result.error {
    background: #fee2e2;
    color: #991b1b;
    border: 1px solid #fecaca;
}

@media (max-width: 1100px) {
    .mid-grid { grid-template-columns: 1fr; }
}

@media (max-width: 560px) {
    .stats-grid { grid-template-columns: 1fr 1fr; }
    .panel-head { flex-direction: column; }
    .notif-actions { width: 100%; }
    .force-btn, .demo-btn { flex: 1; justify-content: center; }
}
</style>
